import React from "react";
import { Route, Routes } from "react-router-dom";

import { NavBar } from "./components/NavBar";
import { Home } from "./pages/Home/Home";
import { Publications } from "./pages/PublicationsPage/Publications";
import { DownloadPage } from "./pages/DownloadPage/Download";
import { DocumentationPage } from "./pages/DocumentationPage/Documentation";

import { Footer } from "./components/Footer";

import "bootstrap/dist/css/bootstrap.min.css";
import "./css/GeneralCSS.css"; // Import this AFTER bootstrap


// Firebase
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent   } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD2mt_VAvhmqF6WxpkYjyvYkofbiJIVMjM",
  authDomain: "parso-website.firebaseapp.com",
  projectId: "parso-website",
  storageBucket: "parso-website.firebasestorage.app",
  messagingSenderId: "534251843925",
  appId: "1:534251843925:web:33696475489a07bceeffdc",
  measurementId: "G-WM0XP89CJ2"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const firestoreDB = getFirestore(app);

export { analytics, logEvent, firestoreDB };

function App() {

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/documentation" element={<DocumentationPage />} />
        <Route path="/publications" element={<Publications />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
      <Footer />
    </>
  );
}

export default App;
